import { findSize } from './clean-department-utils'
import _ from 'lodash'

export function cleanEntityPrinting (entity, department, menuBlob) {
  if (!_.has(entity, 'printing')) return

  cleanPrinters(entity.printing, menuBlob)

  let size = findSize(department)
  if (size) {
    cleanSizes(entity.printing, size.options)
  }
}

function cleanPrinters (printing, menuBlob) {
  const availablePrinters = _.get(menuBlob, 'printers', []).map(next => next.id)

  if (_.has(printing, 'kitchen.printers')) {
    printing.kitchen.printers = printing.kitchen.printers.filter(next => availablePrinters.includes(next))
  }

  if (_.has(printing, 'label.printers')) {
    printing.label.printers = printing.label.printers.filter(next => availablePrinters.includes(next))
  }
}

function cleanSizes (printing, sizeOptions) {
  if (_.has(printing, 'kitchen')) {
    const availableOptions = sizeOptions.map(next => next.id)

    const kitchen = printing.kitchen
    kitchen.excludedSizes = kitchen.excludedSizes.filter(
      next => availableOptions.includes(next))
  }
}
